enum PrescriptionTypeEnum {
    Building = 'Violation',
    Acceptance = 'ViolationAcceptance',
    Warranty = 'ViolationGuarantee',
}

export default PrescriptionTypeEnum;
